<template>
  <v-dialog :model-value="true" fullscreen :transition="false" @keydown.esc="$emit('close')">
    <div class="overlay background-post-text-60 fill-width fill-height" />
    <div class="d-flex flex-column fill-height">
      <div class="close-button-container d-flex justify-end flex-shrink-1">
        <the-button icon custom-colors class="close-button color-post-background" :class="{ desktop: !$vuetify.display.mobile }" @click="$emit('close')">
          <i-custom-close-circle class="size-8" />
        </the-button>
      </div>
      <div class="d-flex flex-grow-1 justify-center align-center">
        <image-viewer
          ref="contentContainer"
          :class="{
            'mb-6': $vuetify.display.mobile,
            'mb-96px': !$vuetify.display.mobile
          }"
          :images="images"
          in-modal
          :initial-image-index="initialImageIndex"
          @modal-outside-image-click="$emit('close')"
        />
      </div>
    </div>
  </v-dialog>
</template>

<script>
import ImageViewer from "@/components/files/ImageViewer.vue"

export default {
  components: {
    ImageViewer
  },
  props: {
    images: {
      type: Array,
      required: true
    },
    initialImageIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {}
  },
  watch: {
    $route() {
      this.$emit("close")
    }
  }
}
</script>

<style lang="scss" scoped>
.mb-96px {
  margin-bottom: 96px;
}

.close-button-container {
  position: relative;
  top: 0;
  z-index: var(--z-index-base);

  :deep(.close-button) {
    margin: 12px;

    &.desktop {
      margin-bottom: 44px;
    }

    .svg-icon {
      height: 32px;
      width: 32px;
    }
  }
}

.overlay {
  position: fixed;
}

:deep(.v-dialog) {
  -webkit-overflow-scrolling: touch;
}
</style>
